import { resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon-warning.svg'


const _withScopeId = n => (_pushScopeId("data-v-f7f96182"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "jr-flex jr-fixed jr-w-full jr-h-full" }
const _hoisted_2 = { class: "jr-absolute jr-top-0 jr-flex jr-flex-col jr-items-center jr-justify-center jr-w-full jr-h-full jr-bg-white jr-z-20" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "jr-mb-5.5",
  src: _imports_0,
  alt: "icon-warning"
}, null, -1))
const _hoisted_4 = { class: "jr-text-xl jr-text-primary jr-mt-6.5 jr-font-bold" }
const _hoisted_5 = ["textContent"]
const _hoisted_6 = { class: "jr-p-5 jr-flex jr-flex-col jr-h-full jr-max-h-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UILayerToggle = _resolveComponent("UILayerToggle")!
  const _component_TransportationColors = _resolveComponent("TransportationColors")!
  const _component_UIGoogleMap = _resolveComponent("UIGoogleMap")!
  const _component_TransportationBarchart = _resolveComponent("TransportationBarchart")!
  const _component_AreaSearchFilter = _resolveComponent("AreaSearchFilter")!
  const _component_AppLoader = _resolveComponent("AppLoader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_UIGoogleMap, {
      onLoad: _ctx.handleMapLoad,
      right: _ctx.captureClip ? 336 : _ctx.filterMinimum ? 390 : 620,
      class: _normalizeClass(["jr-absolute jr-w-full", { 'content': !_ctx.captureClip, 'jr-h-screen': _ctx.captureClip }])
    }, {
      default: _withCtx(() => [
        _createVNode(_component_UILayerToggle, {
          class: "transition jr-absolute jr-top-2",
          "data-html2canvas-ignore": "true",
          label: "選択したエリア",
          onToggle: _ctx.handleAreaToggle,
          style: _normalizeStyle({ right: _ctx.captureClip ? '336px' : _ctx.filterMinimum ? '394px' : '620px' })
        }, null, 8, ["onToggle", "style"]),
        _createVNode(_component_TransportationColors, {
          class: _normalizeClass(["transition-indicator jr-absolute jr-bottom-3.9", { 'jr-shadow-lg': !_ctx.captureClip }]),
          colors: _ctx.colors,
          style: _normalizeStyle({ left: _ctx.captureClip ? '10px' : _ctx.sbMinimum ? '74px' : '250px' })
        }, null, 8, ["class", "colors", "style"]),
        _withDirectives(_createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.errorTitle), 1),
          _createElementVNode("span", {
            class: "jr-whitespace-pre jr-text-primary jr-mt-3 jr-text-sm jr-text-center",
            textContent: _toDisplayString(_ctx.errorMessage)
          }, null, 8, _hoisted_5)
        ], 512), [
          [_vShow, _ctx.isBarchartError || _ctx.isPlotError]
        ])
      ]),
      _: 1
    }, 8, ["onLoad", "right", "class"]),
    _createElementVNode("div", {
      class: _normalizeClass(["jr-w-area-worker transition jr-fixed jr-bg-white", { 'content': !_ctx.captureClip, 'jr-h-screen jr-pt-18': _ctx.captureClip }]),
      style: _normalizeStyle({ right: _ctx.captureClip ? '0' : _ctx.filterMinimum ? '60px' : '292px' })
    }, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_TransportationBarchart, {
          label: "エリア来訪時の交通手段比率",
          type: _ctx.TransportationBarchartType.VisitArea,
          class: "jr-mb-3.9 jr-flex-1"
        }, null, 8, ["type"]),
        _createVNode(_component_TransportationBarchart, {
          label: "エリア内の交通手段比率",
          class: "jr-flex-1"
        })
      ])
    ], 6),
    _createVNode(_component_AreaSearchFilter, {
      onSearch: _ctx.handleSearch,
      onResize: _ctx.handleFilterResize
    }, null, 8, ["onSearch", "onResize"]),
    (_ctx.isLoadingChart || _ctx.isLoadingScatterPlot)
      ? (_openBlock(), _createBlock(_component_AppLoader, { key: 0 }))
      : _createCommentVNode("", true)
  ]))
}